module.exports = __webpack_public_path__ + "static/img/nongyekeji.c7ad5234.png";